import React from 'react';
import './Skeleton.css';

export default function BlogCardSkeleton() {
    return (
        <div className="flex flex-col overflow-hidden rounded-2xl border border-slider bg-bg p-4 space-y-4 skeleton-fade-in">
            {/* Card Image */}
            <div className="w-full aspect-video rounded-xl shimmer-pulse" />

            {/* Category tag */}
            <div className="h-5 w-24 rounded-full shimmer-pulse" />

            {/* Title */}
            <div className="space-y-2">
                <div className="h-5 w-11/12 rounded shimmer-pulse" />
                <div className="h-5 w-3/4 rounded shimmer-pulse" />
            </div>

            {/* Excerpt */}
            <div className="space-y-1.5 pt-1">
                <div className="h-3.5 w-full rounded shimmer-pulse opacity-70" />
                <div className="h-3.5 w-4/5 rounded shimmer-pulse opacity-70" />
            </div>

            {/* Footer Author & Date */}
            <div className="flex items-center justify-between pt-3 border-t border-slider">
                <div className="flex items-center gap-2">
                    <div className="w-7 h-7 rounded-full shimmer-pulse" />
                    <div className="h-3 w-20 rounded shimmer-pulse" />
                </div>
                <div className="h-3 w-16 rounded shimmer-pulse opacity-60" />
            </div>
        </div>
    );
}

export function BlogCardGridSkeleton({ count = 6 }: { count?: number }) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
            {Array.from({ length: count }).map((_, i) => (
                <BlogCardSkeleton key={i} />
            ))}
        </div>
    );
}
